import React, { useEffect, useState, useCallback, useMemo, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { checkUserPermission } from "../../../common/UserPermission";
import Input from "antd/es/input/Input";
// import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
// import Table from "../../../../components/Datatable/DataTable";
// import config from "../../../../config/config";
// import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../components/Modal/UnDeleteConfirmation";
import { Link, useNavigate } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { MenuItem } from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import { AppContext } from "../../../context/AppContext";

let PERMISSION_DELETE = "delete-employees";

const DeletedEmployees = (props) => {
  const { dateFormate } = useContext(AppContext);
  let selectData = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  // const [selectedData, setSelectedData] = useState([]);
  const [sortingId, setSortingId] = useState(1);
  const [sortingDirection, setSortingDirection] = useState("asc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [data, setData] = useState([]);
  const [selectedCustomerCheckboxIds, setselectedCustomerCheckboxIds] =
    useState("");

  const [filtertext, setFiltertext] = useState("");

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const navigate = useNavigate();

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     setSelectedRows(e.selectedRows.map((x) => x.Id));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Id);
  //     console.log(e.selectedRows.map((x) => x.Id));

  //     const selectedCustomerCheckboxIds =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedCustomerCheckboxIds(selectedCustomerCheckboxIds);
  //     console.log(selectedCustomerCheckboxIds);
  //   }
  // };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    console.log(FilterColumnText, "FilterColumnSearchText");

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = ((sorting.length > 0) ? sorting[0]?.id : "") 

    axios
      .get(
        `${
          config.employeesBaseUrl
        }/employees/managedelete?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setRowCount(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [searchtext, columnFilters, globalFilter, pagination, sorting]);


  const handleDeletePopup = (id, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    if (field === "multipleRowInactive") {
      data = rows.map((el) => el.original.Id).join(",");
    } else {
      data = id;
    }
    const deleteRequestParam = {
      id: data,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  // const contextActions = useMemo(() => {
  //   const handleDeletePopup = () => {
  //     const deleteRequestParam = {
  //       employeeids: selectedCustomerCheckboxIds,
  //     };
  //     localStorage.setItem(
  //       "DeleteRequestParam",
  //       JSON.stringify(deleteRequestParam)
  //     );
  //   };
  //   return (
  //     <button
  //       type="button"
  //       className="btn btn-success btn-sm pull-left "
  //       data-bs-toggle="modal"
  //       data-bs-target="#UnDeleteConfirmationModal"
  //       onClick={handleDeletePopup}
  //     >
  //       <i className="fa fa-trash fa-sm" /> Un Delete
  //     </button>
  //   );
  // }, [data, selectedRows, toggleCleared];

  // Table Data
  const columns = [
    // {
    //   name: "ID",
    //   selector: "Id",
    //   sortable: true,
    // },
    // {
    //   name: "Name",
    //   selector: (row) => row.Firstname + " " + row.Lastname,
    //   sortable: true,
    // },
    // {
    //   name: "E-Mail",
    //   selector: "Email",
    //   sortable: true,
    // },
    // {
    //   name: "Phone Number",
    //   selector: "Phonenumber",
    //   sortable: true,
    // },
    // {
    //   name: "Hourly Pay Rate",
    //   selector: "Hourlypayrate",
    //   sortable: true,
    // },
    {
      header: "ID",
      accessorKey: "Id",
      size:"70",
    },
    {
      header: "Name",
      accessorKey:"Name",
      Cell:({row})=> row.original.Firstname + ' ' + row.original.Lastname
    },
    {
      header: "E-Mail",
      accessorKey: "Email",
    },
    {
      header: "Phone Number",
      accessorKey: "Phonenumber",
      size:"110",
    },
    {
      header:"Deleted On",
      accessorKey:"CreatedOn",
      size:"140",
      Cell:({row})=>moment(row.original.CreatedOn).format(`${dateFormate.toUpperCase()}`),
    },
    {
      header: "Hourly Pay Rate",
      accessorKey: "Hourlypayrate",
      // size:"50",
    },
  ];

  // const handlePerRowsChange = async (page, newPerPage) => {
  //   setperPageSize(newPerPage);
  //   setCurrentPage(page);
  //   handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  // };

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  // };

  // const handleSort = (e, sortingDirection) => {
  //   setSortingId(e.id);
  //   setSortingDirection(sortingDirection);
  //   handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  // };
  // const ChangeFilterText = (e) => {
  //   setSearchText(e.target.value);
  //   setCurrentPage(1);
  //   handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  //   console.log(handleListData);
  // };
  // const rowSelectCritera = row => row.fat > 6;

  // const clickHandler = (e) => {
  //     console.log(e.target.id);
  // }
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content  container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Deleted Customers</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/employees">Employees List</Link>
                </li>
                <li className="breadcrumb-item active">
                  Deleted Employees List
                </li>
              </ul>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div className="col-md-4"></div>
            <div>
              <div className="btn-group pull-right ms-2 ">
                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-dark"
                    style={{ borderRadius: "5px", padding: "8px" }}
                    onClick={() => navigate("/employees")}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row flex-row-reverse">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
              {/* <Input.Search placeholder="Search..." className="search-btn form-control form-control-sm" onChange={ChangeFilterText} /> */}
            </div>
          </div>

          {/* Customer list */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                {/* <DataTable
                  title="Deleted Customer List"
                  columns={columns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  selectableRows
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                /> */}
                <MaterialReactTable
                  columns={columns}
                  //  title="Deleted Customer List"
                  data={data}
                  // positionPagination='top'
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  enableRowActions
                  positionGlobalFilter="left"
                  // editingMode="row"
                  // enableEditing
                  // onEditingRowSave={handleSaveRow}
                  renderRowActionMenuItems={({ row, table }) => [
                    //   checkUserPermission(PERMISSION_EDIT) ? (
                    //     <MenuItem
                    //       key="edit"
                    //       // onClick={() => {
                    //       //   table.setEditingRow(row);
                    //       // }}
                    //       onClick={() =>
                    //         navigate(`/manage-locations/${row.original.Id}`)
                    //       }
                    //     >
                    //       <EditIcon />
                    //       Edit
                    //     </MenuItem>
                    //   ) : (
                    //     ""
                    //   ),
                    checkUserPermission(PERMISSION_DELETE) ? (
                      <MenuItem
                        className="confirm-text"
                        to="#"
                        key="delete"
                        // title="Delete"
                        // data-bs-toggle="modal"
                        // data-bs-target="#DeleteConfirmationModal"
                        // onClick={() => handleDeletePopup(row.original.Id)}
                        // data-bs-toggle="modal"
                        // data-bs-target="#DeleteConfirmationModal"
                        onClick={() =>
                          handleDeletePopup(row.original.Id, "", "")
                        }
                      >
                        {/* <DeleteIcon /> */}
                        UnDelete
                      </MenuItem>
                    ) : (
                      ""
                    ),
                  ]}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      {console.log(table, "tables")}
                      
                    {(table.getIsSomeRowsSelected() ||
                    table.getIsAllRowsSelected()) && (
                      checkUserPermission(PERMISSION_DELETE) ? (
                        <Button
                          // size="small"
                          class="btn btn-sm btn-secondary"
                          style={{display:"flex"}}
                          disabled={
                            !table.getIsSomeRowsSelected() &&
                            !table.getIsAllRowsSelected()
                          }
                          onClick={() =>
                            handleDeletePopup(
                              "",
                              table.getSelectedRowModel().rows,
                              "multipleRowInactive"
                            )
                          }
                          startIcon={<DeleteIcon />}
                          variant="contained"
                        >
                          UnDelete Selected
                        </Button>
                      ) : (
                        ""
                      )
                      )}
                      {/* <Button
                        size="small"
                        onClick={() =>
                          // setPagination({ ...pagination, pageSize: totalRows })
                          setPagination({
                            ...pagination,
                            pageIndex: 0,
                            pageSize: totalRows,
                          })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                  // rowVirtualizerOptions={{
                  //   overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                  //   estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                  // }}
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 10 },
                    showGlobalFilter: true
                    // sorting: { id: "Name", desc: false }, //sort by state by default
                  }}
                  muiPaginationProps={{
                    rowsPerPageOptions: [10, 25, 50, 100, 300],
                  }}
                  manualPagination
                  manualSorting

                  muiTableBodyProps={{
                    sx: () => ({                    
                      '& tr:nth-of-type(even)': {
                         backgroundColor: 'var(--datatable-row-background-color)'
                         //'rgb(237 237 233 / 63%)'
                      },
                      '& td': {borderRight: '1px solid var(--datatable-row-background-hover-color)',
                    lineHeight: '16px',
                      fontWeight: '400',
                      fontSize:'12px',
                      color:'var(--primary-color-800)',
                      fontFamily:'Inter'},
                     
                      '& tr': {lineHeight: '16px',
                      fontWeight: '400',
                      fontSize:'12px',
                      color:'var(--primary-color-800)',
                      fontFamily:'Inter'}
                    })
                    }}

                    muiTableHeadCellProps={{
                      sx: theme => ({
                        background: 'var(--datatable-row-background-color)',//'#e9e9e9',
                        borderRight: '1px solid var(--datatable-row-background-hover-color)',
                        lineHeight: '16px',
                        fontWeight: '500',
                        fontSize:'14px',
                        color:'var(--primary-color-800)',
                        fontFamily:'Inter'
                      })
                    }}

                    muiSelectCheckboxProps={{ sx: theme => ({                    
                      lineHeight: '16px',
                      fontWeight: '400',
                      fontSize:'12px',
                      color:'var(--prinary-color-800)',
                      fontFamily:'Inter'
                    })
                  }}
                  muiSelectAllCheckboxProps={{ sx: theme => ({
                   
                    lineHeight: '16px',
                    fontWeight: '400',
                    fontSize:'12px',
                    color:'var(--prinary-color-800)',
                    fontFamily:'Inter'
                  })
                }}
  

                  muiToolbarAlertBannerProps={
                     // isError
                    // ? {
                    //   color: "error",
                    //   children: "Error loading data",
                    // }
                    // : undefined                
                    {
                      isError: ()=>({color: 'error',
                      children: 'Error loading data'
                    }),
                      sx: theme => ({
                        background: 'var(--datatable-row-background-color)',//'#e9e9e9',
                        lineHeight: '16px',
                        fontWeight: '500',
                        fontSize:'14px',
                        color:'var(--primary-color-800)',
                        fontFamily:'Inter'
                      })  
                    }}
                  
                  // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column

                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  // enableColumnVirtualization={false}

                  // enableColumnVirtualization

                  state={{
                    // columnFilters, // for termp comment filteron column
                    globalFilter,
                    filtertext,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <DeleteConfirmationModal
        deleteApiUrl={`${config.employeesBaseUrl}/employees/undeletemutiple`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default DeletedEmployees;
